<template>
  <div class="Dashbord">
    <FloatingButton
      :top="loc_top"
      :right="loc_right"
      :bottom="loc_bottom"
      :left="loc_left"
    ></FloatingButton>
    <ActionsNavVinogradi></ActionsNavVinogradi>
    <div class="Actions__Content">
      <v-container fluid>
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->
        <section class="TankRoom">
          <h2>
            <span>{{ naslov }}</span>
          </h2>

          <template>
            <div class="TankHolder">
              <div v-for="vineyard in items" :key="vineyard.id">
                <template>
                  <div
                    :class="'VineyardDetails Tank ' + vineyard.name"
                    :key="vineyard.id"
                    :data-vineyard-id="vineyard.id"
                    :data-vineyard-name="vineyard.name"
                    @click="selectTank(vineyard)"
                  >
                    <!-- /.Tank__Bar -->
                    <div class="Tank__Content">
                      <p
                        class="vineType"
                        v-if="vineyard.name === undefined"
                      ></p>
                      <h4 v-if="vineyard.name.length <= 20">
                        <router-link
                          :to="{
                            name: 'single_vineyard',
                            params: { id: vineyard.id, name: vineyard.name },
                          }"
                          >{{ vineyard.name }}</router-link
                        >
                      </h4>
                      <h4 v-else>
                        <router-link
                          :to="{
                            name: 'single_vineyard',
                            params: { id: vineyard.id, name: vineyard.name },
                          }"
                          :title="vineyard.name"
                          >{{ vineyard.name.substring(0, 18) }}...</router-link
                        >
                      </h4>
                      <div class="TankDetails">
                        <div class="TankDetails__Item" style="width: 100%">
                          <span class="label" style="width: 50%">
                            {{ vineyard.surfaceUnderPlantsInHa }} ha
                          </span>
                          <span class="value" style="width: 50%">
                            <img
                              style="width: 32px; height: 32px"
                              src="../assets/iconsTanks/povrsina.png"
                              alt="Tank Image"
                              title="Površina pod zasadom"
                            />
                          </span>
                        </div>
                        <div class="TankDetails__Item">
                          <span class="label" style="width: 50%">
                            {{ vineyard.blocks.length }}
                          </span>
                          <span class="value" style="width: 50%">
                            <img
                              style="width: 32px; height: 32px"
                              src="../assets/iconsTanks/parcela.png"
                              alt="Tank Image"
                              title="Broj parcela u vinogradu"
                            />
                          </span>
                        </div>
                        <div class="TankDetails__Item">
                          <span class="label" style="width: 50%">
                            {{ vineyard.grapes.length }}
                          </span>
                          <span class="value" style="width: 50%">
                            <img
                              style="width: 32px; height: 32px"
                              src="../assets/iconsTanks/sorti.png"
                              alt="Tank Image"
                              title="Broj zasađenih sorti u vinogradu"
                            />
                          </span>
                        </div>
                        <div class="TankDetails__Item">
                          <span class="label" style="width: 50%">
                            {{ formatInt(vineyard.rows.length) }}
                          </span>
                          <span class="value" style="width: 50%">
                            <img
                              style="width: 32px; height: 32px"
                              src="../assets/iconsTanks/redova.png"
                              alt="Tank Image"
                              title="Broj redova u vinogradu"
                            />
                          </span>
                        </div>
                        <div class="TankDetails__Item">
                          <span class="label" style="width: 50%">
                            {{ formatInt(vineyard.plants) }}
                          </span>
                          <span class="value" style="width: 50%">
                            <img
                              style="width: 32px; height: 32px"
                              src="../assets/iconsTanks/cokota.png"
                              alt="Tank Image"
                              title="Broj čokota u vinogradu"
                            />
                          </span>
                        </div>
                      </div>

                      <!-- /.Tank__Img -->

                      <!-- <div class="Tank__Info">
                        <p class="amauntAvailable">{{vineyard.description}}</p>
                      </div> -->
                    </div>
                  </div>
                </template>

                <!-- /.Tank__Content -->
              </div>
              <!-- /.Tank -->
            </div>
            <!-- /.TankHolder -->
          </template>
        </section>
      </v-container>
    </div>
    <!-- /.Actions__Content -->
    <TokenComponent ref="frmtoken" />
  </div>
  <!-- /.Dashboard -->
</template>

<script>
import TokenComponent from "../components/Token";
import { serverBus } from "../main";
import { readJSON, daLiJeVinarija } from "../helpers/Functions";

import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";
//Parts
import ActionsNavVinogradi from "./parts/ActionsNavVinogradi.vue";
import FloatingButton from "./parts/FloatingButtonMulti";

// const MountedMixin = {
// 	mounted() {
// 		//alert(1);
// 		this.$emit("mounted");
// 	}
// };

export default {
  name: "ware_houses",
  dialog: false,
  components: {
    Breadcrumbs,
    ActionsNavVinogradi,
    FloatingButton,
    TokenComponent,
  },
  data() {
    return {
      // rooms: [],
      // tanks: [],
      actionId: 0,
      items: [],
      all_grape_input_items: [],
      kolicina_vina_u_bacvi: 0,
      akcija: 0,
      floating_akcija: "5",
      window: {
        width: 0,
      },

      loc_top: undefined,
      loc_right: undefined,
      loc_bottom: undefined,
      loc_left: undefined,
      naslov: "",
      vinarija: true,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;

      // alert(this.window.width);

      //alert(this.koliko_tankova_2);
    },
    formatInt(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    selectTank: function (vineyard) {
      let pomInt = 9999;
      let tanks = document.getElementsByClassName("Tank");

      for (let i = 0; i < tanks.length; i++) {
        tanks[i].classList.remove("active");

        if (tanks[i].dataset.vineyardId === vineyard.id.toString()) {
          let nizVrednosti; // = [false, false, false, false, false, true, true, false, true];

          nizVrednosti = [
          false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
            false,
          ];

          serverBus.$emit("disable_action_vineyard", nizVrednosti);

          pomInt = i;
        }
        if (pomInt != 9999) {
          tanks[pomInt].classList.add("active");
        }
      }
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard/all/extended",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.items = response.data;

          let nizVrednosti = [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
              ];

              serverBus.$emit("disable_action_vineyard", nizVrednosti);
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard/all/extended",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items = response.data;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },

  beforeMount() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

    if (this.vinarija) this.naslov = "Pregled vinograda";
    else this.naslov = "Pregled zasada";

    this.loc_top = true;
    this.loc_right = true;
    this.loc_bottom = false;
    this.loc_left = false;

    serverBus.$off("ucitaj_podatke_vinogradi");
    this.getAllSifarnik();

    serverBus.$on("ucitaj_podatke_vinogradi", () => {
      // alert('ucitaj_podatke');

      this.getAllSifarnik();
    });
  },
};
</script>

<style scoped lang='scss'>
@import "../assets/sass/parts/_warehousesType.scss";

.column {
  float: left;
}

.columnVineType {
  float: left;
  text-align: left;
  margin-bottom: 0px;
}

.columnRight {
  float: right;
  color: #8e302f;
  font-weight: bold;
}

.columnRightVineType {
  float: right;
  color: #018389;
  font-weight: bold;
  padding-left: 5px;
}
/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

.TankDetails {
  display: flex;
  padding: 0 10px;
  flex-direction: column;
  // border-left: 1px solid #979797;
  width: 100%;
  @include bp(_1200) {
    padding: 0 10px;
  }
  &__Item {
    > * {
      width: 100%;
      display: inline-block;
      vertical-align: middle;
    }
    margin-bottom: 4px;
    font-family: "NunitoSans", sans-serif;
    font-size: 16px;
    .label {
      width: 50%;
      letter-spacing: 0;
      color: #9b9b9b;
      text-align: right;
      @include bp(_1200) {
        width: auto;
      }
    }
    .value {
      width: 50%;
      color: #000;
    }
    .maka {
      max-width: 200px;
      letter-spacing: 0;
      color: #9b9b9b;
      @include bp(_1200) {
        width: auto;
      }
    }
  }
}
</style>
